import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../../constants/common'
import Button from '../../../../Button'
import { QA_NAME_APPLICANT_PROFILE_EMAILS_COMPOSE } from '../RentalPortalApplicantProfileEmails.constants'
import { useApplicantProfileEmailsCompose } from '../RentalPortalApplicantProfileEmails.hooks'

import PlusIcon from '../../../../../icons/plus.svg'

function ApplicantProfileEmailsComposeButton({ className }) {
  const { t } = useTranslation()

  const { composeTooltipKey, handleClickCompose, isComposeDisabled } =
    useApplicantProfileEmailsCompose()

  return (
    <Button.Text
      beforeIconProps={{ Icon: PlusIcon }}
      className={className}
      disabled={isComposeDisabled}
      qaName={QA_NAME_APPLICANT_PROFILE_EMAILS_COMPOSE}
      text={t('RentalPortal.ApplicantProfileEmailsComposeBtnKey')}
      tooltip={composeTooltipKey ? t(composeTooltipKey) : null}
      tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
      onClick={handleClickCompose}
    />
  )
}

export default ApplicantProfileEmailsComposeButton
